import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
// import cx from "classnames";
// import axios from "axios";
import { Redirect } from "react-router-dom";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
// import styles from "~/components/mobile/pages/Home/style.module.scss";
import * as notificationAction from "~/store/notifications/notificationsActions";
import * as newArticleAction from "~/actions/newArticle";
import { requestAllFeatures } from "~/store/features/featuresActions";
import { resetFollowUpExam } from "~/store/followUpExam/actions";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { loginByFirebase } from "~/store/user/userAction";
import { clearDataSearchFeeCode } from "~/store/fee/feeActions";
import { resetData, setPartnerId } from "~/store/totalData/actions";
import { requestHospitalList } from "~/store/hospital/hospitalActions";
import AppId from "~/utils/partner";
import { partnerInfo } from "~/configs/partnerDetails";
import MenuBarBottom from "~/components/mobile/molecules/MenuBar";
import { NOTI } from "~/utils/constants";
import Modal from "~/components/common/molecules/Modal";
import moment from "moment";
import history from "~/history";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const HomePageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_mobile" */ "~/components/desktop/pages/Home"
    ),
  loading: LoadableLoading,
  delay: 500
});
const HomePageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/Home"
    ),
  loading: LoadableLoading,
  delay: 500
});

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerModal: false
    };
    this.scrollTop = 0;
    this.props.getFeaturedArticle();
    this.menuBarBottomRef = React.createRef();
    // if (this.props.IsAuthenticated) {
    //   this.props.getNotificationOnPage({
    //     category: 1
    //   });
    // }
  }

  handleShowNotiModal = () => {
    const today = moment().format("YYYY/MM/DD");
    const triggerModal = moment(today).isSameOrBefore("2021-02-18");
    const wasTriggered = sessionStorage.getItem("isTriggerModal");
    if (!wasTriggered) {
      if (triggerModal) {
        this.setState({ triggerModal: true });
        sessionStorage.setItem("isTriggerModal", true);
      }
    }
  };

  handleHideNotiModal = () => {
    this.setState({ triggerModal: !this.state.triggerModal });
  };

  componentDidMount() {
    // if (AppId === "dkanphuoc") {
    //   this.handleShowNotiModal();
    // }
    // this.props.resetData();
    // this.props.resetFollowUpExam();
    // this.props.clearDataSearchFeeCode();
    // this.props.setPartnerId(AppId);
    // this.props.requestAllFeatures();
    // this.props.requestHospitalList();
    history.push("/cham-soc-khach-hang");
  }

  render() {
    const { device } = this.props;
    if (AppId === "momo") {
      return <Redirect to="/chon-benh-vien" />;
    }
    return (
      <React.Fragment>
        {/* <Redirect to="/cham-soc-khach-hang" /> */}

        {device === "mobile" ? (
          <HomePageMobile
            {...this.props}
            menuBarBottomRef={this.menuBarBottomRef}
          />
        ) : (
          <HomePageDesktop
            {...this.props}
            menuBarBottomRef={this.menuBarBottomRef}
          />
        )}
        <MenuBarBottom
          menuBarBottomRef={this.props.menuBarBottomRef}
          currentLocation={this.props.location.pathname}
        />
        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={this.state.triggerModal}
          toggle={() => this.handleHideNotiModal()}
          title="Thông báo"
          children={NOTI}
          centered
          className="centered"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user,
    notification,
    newArticle
  } = state;
  return {
    device: type,
    IsAuthenticated: user.IsAuthenticated,
    userInfo: user.info,
    notification,
    newArticle
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNotificationOnPage: data =>
      dispatch(notificationAction.getNotificationOnPage(data)),
    getNotification: data => dispatch(notificationAction.getNotification(data)),
    getFeaturedArticle: () => dispatch(newArticleAction.getFeaturedArticle()),
    requestAllFeatures: () => dispatch(requestAllFeatures()),
    loginByFirebase: idToken => dispatch(loginByFirebase(idToken)),
    resetData: () => dispatch(resetData()),
    resetFollowUpExam: () => dispatch(resetFollowUpExam()),
    clearDataSearchFeeCode: () => dispatch(clearDataSearchFeeCode()),
    setPartnerId: id => dispatch(setPartnerId(id)),
    requestHospitalList: () => dispatch(requestHospitalList())
  };
};

const HomePageHelmet = withTitle({
  component: HomePage,
  title: `${hospitalName.value} | Phần mềm đăng ký khám bệnh online"`
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePageHelmet);
